"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetStore = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const userSlice_1 = require("../user/userSlice");
const applicationSlice_1 = require("../application/applicationSlice");
const modulesSlice_1 = require("../modules/modulesSlice");
const terminalOfflineSlice_1 = require("../terminals/terminalOfflineSlice");
const planSlice_1 = require("../plans/planSlice");
const subsOrderTypeSlice_1 = require("../subscriptionPurchaseOrderType/subsOrderTypeSlice");
const businessSlice_1 = require("../business/businessSlice");
const reportsSlice_1 = require("../reports/reportsSlice");
const outletSlice_1 = require("../outlet/outletSlice");
const unitsSlice_1 = require("../units/unitsSlice");
const terminalSettingsSlice_1 = require("../terminalSettings/terminalSettingsSlice");
const counterGroupsSlice_1 = require("../counterGroup/counterGroupsSlice");
const headerFooterSlice_1 = require("../headerFooter/headerFooterSlice");
const serviceFloorSlice_1 = require("../serviceFloor/serviceFloorSlice");
const tableSlice_1 = require("../table/tableSlice");
const kitchenCountersSlice_1 = require("../kitchenCounters/kitchenCountersSlice");
const waiterSlice_1 = require("../waiters/waiterSlice");
const terminalOnlineSlice_1 = require("../terminals/terminalOnlineSlice");
const subCategoriesSlice_1 = require("../subCategories/subCategoriesSlice");
const categorySlice_1 = require("../categories/categorySlice");
const contactPersonSlice_1 = require("../../modules/contactPerson/contactPersonSlice");
const itemListSlice_1 = require("../itemList/itemListSlice");
const itemsSlice_1 = require("../items/itemsSlice");
const inventorySlice_1 = require("../inventory/inventorySlice");
const vendorSlice_1 = require("../vendor/vendorSlice");
const customerSlice_1 = require("../customer/customerSlice");
const ledgerSlice_1 = require("../ledger/ledgerSlice");
const entitlementSlice_1 = require("../entitlement/entitlementSlice");
const razorpaySlice_1 = require("../razorpay/razorpaySlice");
const purchaseOrderServiceSlice_1 = require("../subscriptionPurchaseOrderService/purchaseOrderServiceSlice");
const appFlavourSlice_1 = require("../appFlavours/appFlavourSlice");
const paymentMethodSlice_1 = require("../paymentMethod/paymentMethodSlice");
const appReducer = (0, toolkit_1.combineReducers)({
    'user/login': userSlice_1.userLoginReducer,
    'user/register': userSlice_1.userRegisterReducer,
    'user/businessLogin': userSlice_1.businessLoginReducer,
    'user/logout': userSlice_1.logoutReducer,
    'user/getUserTokenWithRefreshToken': userSlice_1.getUserTokenWithRefreshTokenReducer,
    'user/getTokenWithRefreshToken': userSlice_1.getTokenWithRefreshTokenReducer,
    'user/fetch': userSlice_1.fetchUserReducer,
    'user/fetchForOwner': userSlice_1.fetchUserForOwnerReducer,
    'user/fetchForFranchise': userSlice_1.fetchUserForFranchiseReducer,
    'user/fetchById': userSlice_1.fetchUserByIdReducer,
    'user/create': userSlice_1.createUserReducer,
    'user/update': userSlice_1.updateUserReducer,
    'user/updateUserProfile': userSlice_1.updateUserProfileReducer,
    'user/resetPassword': userSlice_1.resetPasswordReducer,
    'user/sendOtp': userSlice_1.sendOtpReducer,
    'user/verifyOtp': userSlice_1.verifyOtpReducer,
    'user/adminLogin': userSlice_1.adminLoginReducer,
    'user/fOwnerLogin': userSlice_1.fOwnerLoginReducer,
    'user/sendAdminOtp': userSlice_1.sendAdminOtpReducer,
    'user/verifyAdminOtp': userSlice_1.verifyAdminOtpReducer,
    'application/fetch': applicationSlice_1.applicationFetchReducer,
    'application/create': applicationSlice_1.applicationCreateReducer,
    'application/update': applicationSlice_1.applicationUpdateReducer,
    'modules/fetch': modulesSlice_1.moduleFetchReducer,
    'modules/create': modulesSlice_1.moduleCreateReducer,
    'modules/update': modulesSlice_1.moduleUpdateReducer,
    'modules/fetchModulesInApplication': modulesSlice_1.moduleFetchInApplicationReducer,
    'terminalOffline/fetch': terminalOfflineSlice_1.fetchTerminalOfflineReducer,
    'terminalOffline/create': terminalOfflineSlice_1.createTerminalOfflineReducer,
    'terminalOffline/update': terminalOfflineSlice_1.updateTerminalOfflineReducer,
    'terminalOffline/createHost': terminalOfflineSlice_1.createHostTerminalReducer,
    'terminalOnline/fetch': terminalOnlineSlice_1.fetchTerminalOnlineReducer,
    'terminalOnline/create': terminalOnlineSlice_1.createTerminalOnlineReducer,
    'terminalOnline/update': terminalOnlineSlice_1.updateTerminalOnlineReducer,
    'appFlavour/fetch': appFlavourSlice_1.fetchAppFlavourReducer,
    'appFlavour/create': appFlavourSlice_1.createAppFlavourReducer,
    'appFlavour/update': appFlavourSlice_1.updateAppFlavourReducer,
    'appFlavour/delete': appFlavourSlice_1.deleteAppFlavourReducer,
    'plan/fetch': planSlice_1.planFetchReducer,
    'plan/create': planSlice_1.planCreateReducer,
    'plan/update': planSlice_1.planUpdateReducer,
    'plan/fetchByApplication': planSlice_1.planFetchByApplicationReducer,
    'plan/fetchById': planSlice_1.planFetchByIdReducer,
    'subscriptionPurchaseOrderType/fetch': subsOrderTypeSlice_1.subscriptionOrderTypeFetchReducer,
    'subscriptionPurchaseOrderType/create': subsOrderTypeSlice_1.subscriptionOrderTypeCreateReducer,
    'business/fetch': businessSlice_1.businessFetchReducer,
    'business/create': businessSlice_1.businessCreateReducer,
    'business/update': businessSlice_1.businessUpdateReducer,
    'business/fetchAllBusiness': businessSlice_1.businessFetchAllReducer,
    'business/fetchBusinessById': businessSlice_1.businessFetchByIdReducer,
    'reports/fetchBusinessSummaryCurrent': reportsSlice_1.fetchBusinessSummaryCurrentReducer,
    'reports/fetchBusinessSummary': reportsSlice_1.fetchBusinessSummaryReducer,
    'reports/fetchOutletSummary': reportsSlice_1.fetchOutletSummaryReducer,
    'reports/fetchOutletwiseSummary': reportsSlice_1.fetchOutletwiseSummaryReducer,
    'reports/fetchOutletSummaryForOutlet': reportsSlice_1.fetchOutletSummaryForOutletReducer,
    'reports/fetchOutletSummaryForFranchise': reportsSlice_1.fetchOutletwiseSummaryForFranchiseReducer,
    'reports/fetchBillwiseReport': reportsSlice_1.fetchBillwiseReportReducer,
    'reports/fetchDaywiseReport': reportsSlice_1.fetchDaywiseReportReducer,
    'reports/fetchItemWiseReport': reportsSlice_1.fetchItemWiseReportReducer,
    'reports/fetchInventoryReport': reportsSlice_1.fetchInventoryReportReducer,
    'reports/fetchUserwiseReport': reportsSlice_1.fetchUserwiseReportReducer,
    'reports/fetchCounterWiseReport': reportsSlice_1.fetchCounterWiseReportReducer,
    'reports/fetchWriteOffReport': reportsSlice_1.fetchWriteOffReportReducer,
    'reports/fetchDuplicateBillReport': reportsSlice_1.fetchDuplicateBillReportReducer,
    'reports/fetchPaymentwiseReport': reportsSlice_1.fetchPaymentwiseReportReducer,
    'outlet/fetch': outletSlice_1.fetchOutletReducer,
    'outlet/create': outletSlice_1.createOutletReducer,
    'outlet/update': outletSlice_1.updateOutletReducer,
    'outlet/fetchOutletsForOwner': outletSlice_1.fetchOutletsForOwnerReducer,
    'outlet/fetchOutletsForFranchise': outletSlice_1.fetchOutletsForFranchiseReducer,
    'outlet/fetchSubBusiness': outletSlice_1.fetchSubBusinessReducer,
    'units/fetch': unitsSlice_1.fetchUnitsReducer,
    'units/create': unitsSlice_1.createUnitsReducer,
    'units/update': unitsSlice_1.updateUnitsReducer,
    'units/import': unitsSlice_1.importUnitsReducer,
    'terminalSettings/fetch': terminalSettingsSlice_1.fetchTerminalSettingsReducer,
    'terminalSettings/create': terminalSettingsSlice_1.createTerminalSettingsReducer,
    'terminalSettings/update': terminalSettingsSlice_1.updateTerminalSettingsReducer,
    'counterGroups/fetch': counterGroupsSlice_1.fetchCounterGroupsReducer,
    'counterGroups/fetchAll': counterGroupsSlice_1.fetchAllCounterGroupsReducer,
    'counterGroups/create': counterGroupsSlice_1.createCounterGroupsReducer,
    'counterGroups/update': counterGroupsSlice_1.updateCounterGroupsReducer,
    'counterGroups/import': counterGroupsSlice_1.importCounterGroupsReducer,
    'headerFooter/fetch': headerFooterSlice_1.fetchHeaderFooterReducer,
    'headerFooter/create': headerFooterSlice_1.createHeaderFooterReducer,
    'headerFooter/update': headerFooterSlice_1.updateHeaderFooterReducer,
    'serviceFloor/fetch': serviceFloorSlice_1.fetchServicefloorReducer,
    'serviceFloor/fetchAll': serviceFloorSlice_1.fetchAllServicefloorReducer,
    'serviceFloor/create': serviceFloorSlice_1.createServicefloorReducer,
    'serviceFloor/update': serviceFloorSlice_1.updateServicefloorReducer,
    'table/fetch': tableSlice_1.fetchTableReducer,
    'table/create': tableSlice_1.createTableReducer,
    'table/update': tableSlice_1.updateTableReducer,
    'kitchenCounters/fetch': kitchenCountersSlice_1.fetchKitchenCounterReducer,
    'kitchenCounters/create': kitchenCountersSlice_1.createKitchenCounterReducer,
    'kitchenCounters/update': kitchenCountersSlice_1.updateKitchenCounterReducer,
    'kitchenCounters/import': kitchenCountersSlice_1.importKitchenCounterReducer,
    'waiters/fetch': waiterSlice_1.fetchWaiterReducer,
    'waiters/create': waiterSlice_1.createWaiterReducer,
    'waiters/update': waiterSlice_1.updateWaiterReducer,
    'subCategories/fetch': subCategoriesSlice_1.fetchSubCategoryReducer,
    'subCategories/create': subCategoriesSlice_1.createSubCategoryReducer,
    'subCategories/update': subCategoriesSlice_1.updateSubCategoryReducer,
    'categories/fetch': categorySlice_1.fetchCategoryReducer,
    'categories/create': categorySlice_1.createCategoryReducer,
    'categories/update': categorySlice_1.updateCategoryReducer,
    'contactPerson/fetch': contactPersonSlice_1.fetchContactPersonReducer,
    'contactPerson/search': contactPersonSlice_1.searchContactPersonReducer,
    'contactPerson/create': contactPersonSlice_1.createContactPersonReducer,
    'contactPerson/update': contactPersonSlice_1.updateContactPersonReducer,
    'itemList/fetch': itemListSlice_1.fetchItemListReducer,
    'itemList/create': itemListSlice_1.createItemListReducer,
    'itemList/update': itemListSlice_1.updateItemListReducer,
    'items/fetch': itemsSlice_1.fetchItemsReducer,
    'items/create': itemsSlice_1.createItemsReducer,
    'items/update': itemsSlice_1.updateItemsReducer,
    'items/search': itemsSlice_1.searchItemsReducer,
    'items/import': itemsSlice_1.importItemsReducer,
    'inventory/fetchLatestInventory': inventorySlice_1.fetchLatestInventoryReducer,
    'inventory/update': inventorySlice_1.updateInventoryReducer,
    'vendor/fetch': vendorSlice_1.fetchVendorReducer,
    'vendor/create': vendorSlice_1.createVendorReducer,
    'vendor/update': vendorSlice_1.updateVendorReducer,
    'customer/fetch': customerSlice_1.fetchCustomerReducer,
    'customer/create': customerSlice_1.createCustomerReducer,
    'customer/update': customerSlice_1.updateCustomerReducer,
    'customer/fetchDefaultCustomer': customerSlice_1.fetchDefaultCustomerReducer,
    'customer/createDefaultCustomer': customerSlice_1.createDefaultCustomerReducer,
    'customer/search': customerSlice_1.searchCustomerReducer,
    'customer/checkCustomerExists': customerSlice_1.checkCustomerExistsReducer,
    'ledger/fetchAllLedgerEntry': ledgerSlice_1.fetchAllLedgerEntryReducer,
    'ledger/fetchLatestLedgerEntry': ledgerSlice_1.fetchLatestLedgerEntryReducer,
    'ledger/fetchTbpBillAmount': ledgerSlice_1.fetchTbpBillAmountReducer,
    'ledger/create': ledgerSlice_1.createLedgerReducer,
    'ledger/creditRepay': ledgerSlice_1.creditRepayReducer,
    'entitlement/fetch': entitlementSlice_1.entitlementReducer,
    'razorpay/create': razorpaySlice_1.razorpayReducer,
    'subscriptionPurchaseOrderService/fetch': purchaseOrderServiceSlice_1.fetchPurchaseOrderServiceReducer,
    'subscriptionPurchaseOrderService/create': purchaseOrderServiceSlice_1.createPurchaseOrderServiceReducer,
    'subscriptionPurchaseOrderService/update': purchaseOrderServiceSlice_1.updatePurchaseOrderServiceReducer,
    'subscriptionPurchaseOrderService/cancel': purchaseOrderServiceSlice_1.cancelPurchaseOrderServiceReducer,
    'subscriptionPurchaseOrderService/fetchLastSuccess': purchaseOrderServiceSlice_1.fetchLastSuccessPurchaseOrderServiceReducer,
    'subscriptionPurchaseOrderService/fetchPending': purchaseOrderServiceSlice_1.fetchPendingPurchaseOrderServiceReducer,
    'paymentMethod/list': paymentMethodSlice_1.fetchPaymentMethodReducer,
    'paymentMethod/create': paymentMethodSlice_1.createPaymentMethodReducer,
    'paymentMethod/update': paymentMethodSlice_1.updatePaymentMethodReducer,
    'paymentMethod/bulk_save': paymentMethodSlice_1.bulkSavePaymentMethodReducer,
    'paymentMethod/create_default': paymentMethodSlice_1.createDefaultPaymentMethodReducer,
    'reports/fetchDownloadReport': reportsSlice_1.downloadReportsReducer,
    'reports/fetchBillDetails': reportsSlice_1.fetchBillDetailsReducer,
    'reports/fetchWaiterItemWiseReport': reportsSlice_1.fetchWaiterItemWiseReportReducer,
    'reports/fetchWaiterCommissionReport': reportsSlice_1.fetchWaiterCommissionReportReducer,
    'reports/fetchWaiterMonthWiseReport': reportsSlice_1.fetchWaiterMonthWiseReportReducer,
    'reports/fetchWaiterSalesReport': reportsSlice_1.fetchWaiterSalesReportReducer
});
const rootReducer = (state, action) => {
    // When the RESET_STATE action is dispatched, state becomes undefined
    if (action.type === 'RESET_STATE') {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};
const xposStore = (0, toolkit_1.configureStore)({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
});
const resetStore = () => ({ type: 'RESET_STATE' });
exports.resetStore = resetStore;
exports.default = xposStore;
